import qs from 'qs';

function paramsSerializer(params) {
  return qs.stringify(params, { indices: false, arrayFormat: 'brackets' });
}

export default paramsSerializer;
